import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Messages from "./pages/Messages";
import Tasks from "./pages/Tasks";
import Alerts from "./pages/Alerts";
import Logs from "./pages/Logs";
import Brain from "./pages/Brain";
import Advisors from "./pages/Advisors";
import Salon from "./pages/Salon";
import NexusLandingPage from "./pages/NexusLandingPage";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-background font-mono text-xs text-neutral-500">Initialisation de NEXUS…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid #1A1A1A", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontSize: "12px" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<NexusLandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/brain" element={<Brain />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:projectId" element={<ProjectDetail />} />
            <Route path="/advisors" element={<Advisors />} />
            <Route path="/salon" element={<Salon />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/logs" element={<Logs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
